// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z6TY0NDiMU4umra__JQP{align-items:center;width:311px;padding:12px}.Phm5pl1MRMAJO56E6cci{padding:8px 12px 8px 8px}.l44CwlcdZzAnIB8lYJ3d{display:flex}.l44CwlcdZzAnIB8lYJ3d>div{align-items:center;margin-bottom:0;display:flex}.l44CwlcdZzAnIB8lYJ3d>div:first-of-type{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectLabel": `Z6TY0NDiMU4umra__JQP`,
	"multiSelectPlaceholder": `Phm5pl1MRMAJO56E6cci`,
	"selectLabelTrigger": `l44CwlcdZzAnIB8lYJ3d`
};
export default ___CSS_LOADER_EXPORT___;
